import { HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import Keycloak from 'keycloak-js';
import { FileUploader, FileUploaderOptions, Headers } from 'ng2-file-upload';

@Injectable({ providedIn: 'root' })
export class FileUploaderService {
  private keycloak = inject(Keycloak);

  createFileUploader(options: FileUploaderOptions): FileUploader {
    const headers = this.getHeadersForFileUploader();

    return new FileUploader({ headers, autoUpload: true, ...options });
  }

  getHeadersForFileUploader(): Headers[] {
    const requestHeaders = this.getContentHeaders();

    return requestHeaders.keys().map((name: string) => {
      const values = requestHeaders?.getAll(name);

      return {
        name,
        value: values[0],
      };
    });
  }

  private getContentHeaders(): HttpHeaders {
    const token = this.keycloak.token;

    return new HttpHeaders({
      Accept: 'application/json;charset=utf-8',
      Authorization: `Bearer ${token}`,
    });
  }
}
